module.exports = __webpack_public_path__ + "media/old_images/icon-arrow-back-505e0261.svg";